import {RESTORE_DESIGN} from "../constants/action-types";

export const restoreDesign = (designs) => ({
  type: RESTORE_DESIGN,
  payload: {
    designs
  }
});
